export const lightTheme = {
  body: "#FFFFFF",
  text: "#000000",
  textLight: "#0C0C0D44",
  toggleBorder: "#FFF",
  gradient: "linear-gradient(#39598A, #79D7ED)",
  link: "blue",
};

export const darkTheme = {
  body: "#000000",
  text: "#FAFAFA",
  textLight: "#0C0C0D",
  toggleBorder: "#6B8096",
  gradient: "linear-gradient(#091236, #1E215D)",
};
